var $cc3ec3110fcc34c8$exports = {};
$cc3ec3110fcc34c8$exports = {
    "replaceMessage": `Solte o arquivo para substituir`
};


export {$cc3ec3110fcc34c8$exports as default};
//# sourceMappingURL=pt-BR.mjs.map
